var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1782 11.1784C31.8291 10.5276 31.8291 9.47228 31.1782 8.82141C30.5273 8.17053 29.472 8.17053 28.8212 8.82141L19.9997 17.6429L11.1782 8.82141C10.5273 8.17053 9.47204 8.17053 8.82116 8.82141C8.17029 9.47228 8.17029 10.5276 8.82116 11.1784L17.6427 19.9999L8.82116 28.8214C8.17029 29.4723 8.17029 30.5276 8.82116 31.1784C9.47204 31.8293 10.5273 31.8293 11.1782 31.1784L19.9997 22.3569L28.8212 31.1784C29.472 31.8293 30.5273 31.8293 31.1782 31.1784C31.8291 30.5276 31.8291 29.4723 31.1782 28.8214L22.3567 19.9999L31.1782 11.1784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.ae19dd9f92fc461bf01ec6e81e4861cd.svg";
export { ForwardRef as ReactComponent };